export enum ToolTypes {
  jsonata = 'jsonata',
  putContent = 'put_content',
  search = 'search',
  aiGena = 'aigena'
}
